import R from '../../../core-res/R';
function getSizeVariantStyle(size) {
    switch (size) {
        case 'medium':
            return {
                frame: createFrameStyle(24),
                radio: createRadioStyle(22),
                bullet: createBulletStyle(10),
            };
        case 'small':
            return {
                frame: createFrameStyle(16),
                radio: createRadioStyle(16),
                bullet: createBulletStyle(6, R.border.width.thick),
            };
        default:
            throw new Error(`Unknown RadioButton size: ${size}`);
    }
}
function getLabelVariant(size) {
    switch (size) {
        case 'medium':
            return 'ui-baseline';
        case 'small':
            return 'ui-tiny';
        default:
            throw new Error(`Unknown RadioButton size: ${size}`);
    }
}
export { getSizeVariantStyle, getLabelVariant };
function createFrameStyle(pt) {
    return {
        width: pt,
        height: pt,
    };
}
function createRadioStyle(pt) {
    return {
        width: pt,
        height: pt,
        borderRadius: 0.5 * pt,
    };
}
function createBulletStyle(pt, borderWidth = R.border.width.bold) {
    return {
        width: pt,
        height: pt,
        borderRadius: 0.5 * pt,
        borderWidth,
    };
}
